import { defineMessages } from 'react-intl';

export default defineMessages({
  summaryHeading: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-heading',
    defaultMessage: 'Optimized to deliver maximum revenue',
  },
  summaryBodyParagraph1: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-body-paragraph-1',
    defaultMessage:
      'SmartRate will explore credit amounts to determine which levels deliver the strongest performance and conversion.',
  },
  summaryBodyParagraph2: {
    id: 'smart-rate.how-smart-rate-works.maximizes-revenue-panel.summary-body-paragraph-2',
    defaultMessage:
      'Sometimes multiple bookings at a lower level earn more than one booking at a higher credit level, while other times the opposite is true. Learn more.',
  },
});
